/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import Group from "vux/src/components/group/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import SearchBar from '@/components/SearchBar';
import UserLogo from '@/components/UserLogo';
import utils from '@/utils/utils';
import Tags from '@/components/Tags';
import { getWorkerList, batchDesignate, getAssignInfo, getTempDispatch } from '@/api';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    XButton: XButton,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    SearchBar: SearchBar,
    UserLogo: UserLogo,
    Tags: Tags
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: String,
    orderInfo: Object,
    isAssign: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      loading: false,
      stateTagList: [],
      skillTagList: [],
      groupList: [],
      currValue: this.value,
      pageIndex: 0,
      pageSize: 10,
      keyword: '',
      params: {
        searchGroupId: '',
        skill_label: '',
        state_label: ''
      },
      list: [],
      checkAssign: -1,
      // 指派人员id
      checkAssignImg: {
        name: '',
        url: ''
      },
      // 指派人员头像
      checkCoordList: [],
      //
      checkCoordListImg: [],
      slotsDefaultLength: 0
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      // eslint-disable-next-line
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - (4 + 4) * fontSize;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      var _this = this;

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.currValue = false;
          }
        });

        if (val && this.isAssign) {
          this.getDefault();
        }
      } else {
        this.$setLeft({
          control: false
        });
      }

      this.$emit('input', val);
    }
  },
  methods: {
    getCtx: function getCtx(row) {
      var distance = utils.getDistance(row.longitude, row.latitude, this.orderInfo.custom_longitude, this.orderInfo.custom_latitude);
      var ctx = distance === -1 ? '-' : (distance / 1000).toFixed(1) + 'km';

      if (row.loc_update_time) {
        ctx += "\uFF08".concat(utils.getTimeWord(row.loc_update_time), "\uFF09");
      }

      return ctx;
    },
    loadList: function loadList(op) {
      var _this2 = this;

      getWorkerList({
        pageIndex: this.pageIndex++,
        pageSize: this.pageSize,
        keyword: this.keyword,
        searchGroupId: this.params.searchGroupId,
        skill_label: this.params.skill_label,
        state_label: this.params.state_label,
        roleId: 2
      }).then(function (res) {
        if (op === 'search') {
          _this2.list = [];
        }

        _this2.$refs['workerList'] && _this2.$refs['workerList'].donePullup();
        _this2.$refs['workerList'] && _this2.$refs['workerList'].donePulldown();

        if (res.success) {
          _this2.list = _this2.list.concat(res.data);

          if (res.data.length < _this2.pageSize) {
            _this2.$refs['workerList'] && _this2.$refs['workerList'].disablePullup();
          }
        } else {// 暂缺
        }
      });
    },
    resetList: function resetList() {
      // this.keyword = ''
      this.list = [];
      this.pageIndex = 0;
      this.$refs['workerList'].enablePullup();
      this.loadList('search');
    },
    reset: function reset() {
      this.params = {
        searchGroupId: '',
        skill_label: '',
        state_label: ''
      }; // this.keyword = ''

      this.list = [];
      this.pageIndex = 0;
      this.$refs['workerList'].enablePullup();
      this.loadList('search');
    },
    onPulldownLoading: function onPulldownLoading() {
      this.resetList();
    },
    onPullupLoading: function onPullupLoading() {
      this.loadList();
    },
    onCheckOk: function onCheckOk(ids) {
      this.currValue = false;
      var names = this.list.filter(function (item) {
        return ids.indexOf(item.id) !== -1;
      }).map(function (item) {
        return item.name;
      });
      this.$emit('on-ok', ids, names);
    },
    // 选择指派人员
    assign: function assign(index) {
      var user = this.list[index];
      this.checkAssign = user.id;
      this.checkAssignImg.name = user.name;
      this.checkAssignImg.url = user.avatar; // 判断是否是协同 是的话去掉协同
      // let checkIndex = this.checkCoordList.indexOf(user.id)
      // if (checkIndex !== -1) {
      //   this.checkCoordList.splice(checkIndex, 1)
      //   this.checkCoordListImg.splice(checkIndex, 1)
      // }
    },
    // 选择协同人员
    coord: function coord(index) {
      var user = this.list[index];
      var checkIndex = this.checkCoordList.indexOf(user.id);

      if (checkIndex === -1) {
        this.checkCoordList.push(user.id);
        this.checkCoordListImg.push({
          name: user.name,
          url: user.avatar
        }); // 判断是否是指派 是的话去掉指派
        // if (this.checkAssign === user.id) {
        //   this.checkAssign = -1
        //   this.checkAssignImg = {}
        // }
      } else {
        this.checkCoordList.splice(checkIndex, 1);
        this.checkCoordListImg.splice(checkIndex, 1);
      }
    },
    // 提交指派和协同人员
    submit: function submit() {
      var _this3 = this;

      if (!this.checkAssign || this.checkAssign === -1) {
        this.$vux.toast.text('请选择指派人员');
        return;
      }

      this.loading = true;
      batchDesignate({
        oidList: [this.orderId],
        workerId: this.checkAssign,
        coordinations: this.checkCoordList.map(function (item) {
          return {
            id: item
          };
        })
      }).then(function (res) {
        _this3.loading = false;

        if (res.success) {
          _this3.$vux.toast.text('指派成功');

          _this3.currValue = false;

          _this3.$emit('on-success');
        } else {
          _this3.$vux.toast.text(res.message);
        }
      });
    },
    // 将16进制转为rgba
    hexToRgba: function hexToRgba(hex, opacity) {
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;

      if (hex && reg.test(hex)) {
        // 若为#FFF之类的4位色值 先转换成6位色值
        if (hex.length === 4) {
          var hexNew = '#';

          for (var i = 1; i < 4; i++) {
            hexNew += hex.slice(i, i + 1).concat(hex.slice(i, i + 1));
          }

          hex = hexNew;
        } // 处理6位色值 生成rgba


        var rgba = [];

        for (var _i = 1; _i < 7; _i += 2) {
          rgba.push(parseInt('0x' + hex.slice(_i, _i + 2)));
        }

        return "rgba(".concat(rgba.join(','), ", ").concat(opacity, ")");
      }
    },
    getDefault: function getDefault() {
      var _this4 = this;

      getTempDispatch({
        orderTypeTmplId: this.orderInfo.fk_t_ep_ordertype_tmpl_id
      }).then(function (res) {
        if (res.success) {
          var principal = (res.data.principal || [])[0];

          if (principal) {
            _this4.checkAssign = principal.fk_t_ep_user_id;
            _this4.checkAssignImg.name = principal.user_name;
          }

          var coordinator = res.data.coordinator || [];
          _this4.checkCoordList = coordinator.map(function (v) {
            return v.fk_t_ep_user_id;
          });
          _this4.checkCoordListImg = coordinator.map(function (v) {
            return {
              name: v.user_name,
              id: v.fk_t_ep_user_id
            };
          });
        }
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.loadList();
    getAssignInfo({
      code: 1
    }, {
      code: 2
    }).then(function (_ref) {
      var res1 = _ref.res1,
          res2 = _ref.res2,
          res3 = _ref.res3;
      _this5.stateTagList = res1.data.map(function (item) {
        var tem = {};
        tem['value'] = item.id.toString();
        tem['name'] = item.name;
        return tem;
      });
      _this5.skillTagList = res2.data.map(function (item) {
        var tem = {};
        tem['value'] = item.id.toString();
        tem['name'] = item.name;
        return tem;
      });
      _this5.groupList = res3.data.map(function (item) {
        var tem = {};
        tem['value'] = item.id.toString();
        tem['name'] = item.NAME;
        return tem;
      });
    });
  }
};